import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Link from 'gatsby-link'
import Typography from '@material-ui/core/Typography'
import styles from './styles'

const style= {

    mainDiv: {
        marginTop:'20px',
        borderBottom:'1px solid rgba(0,0,0,.5)',
        paddingLeft:'20px',
        marginRight:'8em',
        marginLeft:'8em'
    },
    policyClass:{
      padding:'3rem'
    }
}


const PolicyList = ({classes,title,key,summary,uid})=> {

   
  return (

    
    <div style={style.mainDiv} key={key}>

    <Grid container className={classes.policyContents}>
            <Grid item xs={12} lg={12} xl={12} className={classes.centred}>
              
              <div className={classes.policyCentered}> <Link className={classes.link} to={`/policies/${uid}`}><Typography variant="title" className={classes.h1text}>
                {title}
              </Typography></Link></div>
              <div
              dangerouslySetInnerHTML={{ __html: summary  }}
              className={classes.allpoliciescontent}
            />

            </Grid>
          </Grid>


    </div>
  )
}

export default withStyles(styles)(PolicyList)



// WEBPACK FOOTER //
// ./src/components/policy/policyList.js